import { render, staticRenderFns } from "./FavouriteProduct.vue?vue&type=template&id=3c993529&"
import script from "./FavouriteProduct.vue?vue&type=script&lang=js&"
export * from "./FavouriteProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports